import { useDispatch, useSelector } from 'react-redux';
import { DataLayoutPrefs } from '@he-novation/config/types/dataLayout.types';
import { UserPrefs } from '@he-novation/config/types/user.types';

import LocalStorageWrapper from '$helpers/LocalStorageWrapper';
import { updateUserPreferences } from '$redux/user/userActions';
import { preferencesSelector } from '$redux/user/userSelectors';

function getLayoutPrefs(
    layoutPrefsStorage: 'preferences' | 'localStorage',
    name: string | null,
    preferences: UserPrefs
): DataLayoutPrefs | undefined {
    if (!name) return undefined;
    if (layoutPrefsStorage === 'localStorage') {
        const localStoragePrefs = LocalStorageWrapper.getItem('layout-prefs-' + name);
        if (localStoragePrefs) return JSON.parse(localStoragePrefs);
    }
    return preferences.ui.dataLayouts?.[name];
}

export function useDataLayoutPrefs(
    layoutPrefsStorage: 'preferences' | 'localStorage',
    name: string | null
): {
    saveLayoutPrefs: (userUuid: string, prefs: DataLayoutPrefs) => void;
    layoutPrefs?: DataLayoutPrefs;
} {
    const { preferences }: { preferences: UserPrefs } = useSelector(preferencesSelector);
    const dispatch = useDispatch();

    return {
        saveLayoutPrefs: (userUuid, prefs: DataLayoutPrefs) => {
            if (!name) return;
            if (layoutPrefsStorage === 'localStorage') {
                LocalStorageWrapper.setItem('layout-prefs-' + name, JSON.stringify(prefs));
                return;
            }

            if (!preferences) return;
            if (!preferences.ui.dataLayouts) preferences.ui.dataLayouts = {};
            preferences.ui.dataLayouts[name] = { ...preferences.ui.dataLayouts[name], ...prefs };
            dispatch(updateUserPreferences(userUuid, preferences));
        },
        layoutPrefs: getLayoutPrefs(layoutPrefsStorage, name, preferences)
    };
}
